import Layout from "../../components/Layout";
export const Page = () => {
    return <Layout >
        <div className="container">
            <div className="article-container">
                <h1>
                    Приложение для сенсорных панелей
                </h1>


                <div className=" w-100 align-start d-flex flex-column">
                    <p >
                        Приложение для сенсорных панелей(Touch Panel Application) представляет собой embedded версию клиента SCADA NPT Compact   для панелей отображения с сенсорным экраном. Такие панели широко применяются в энергетике, нефтегазовой отрасли, водоснабжении, на транспорте и в других отраслях, где требуется контроль и управление сложными процессами.
                    </p>
                    <p>
                        Основные функции и задачи приложения для сенсорных панелей(Touch Panel Application) включают:
                    </p>



                    <ul className=" description__list">
                        <li className="mb-1 description__number-li">
                            Визуализация процессов
                            <ul>
                                <li> Отображение данных в реальном времени (графики, диаграммы, схемы технологических процессов).</li>
                                <li> Предоставление операторам наглядной информации о состоянии оборудования и параметрах системы.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li">
                            Управление оборудованием
                            <ul>
                                <li>Возможность управления процессами через сенсорный интерфейс (включение/выключение оборудования, изменение настроек).</li>
                                <li>Упрощение взаимодействия оператора с системой.</li>

                            </ul>
                        </li>
                        <li className="mb-1 description__number-li">
                            Мониторинг и диагностика
                            <ul>
                                <li>Отображение данных с датчиков и контроллеров.</li>
                                <li> Оповещение о нештатных ситуациях (аварии, отклонения от нормы).</li>
                                <li> Анализ исторических данных для выявления тенденций и проблем.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li">
                            Повышение эффективности
                            <ul>
                                <li>Оптимизация процессов за счет оперативного доступа к информации.</li>
                                <li> Снижение времени реакции на аварийные ситуации.</li>
                            </ul>
                        </li>
                        <li className="mb-1 description__number-li">
                            Повышение удобства использования
                            <ul>
                                <li>Интуитивно понятный интерфейс для операторов.</li>
                                <li>Возможность настройки экранов под конкретные задачи.</li>
                            </ul>
                        </li>

                        <li className="mb-1 description__number-li">
                            Добавление мобильности и гибкости
                            <ul>
                                <li> Использование панелей в различных условиях (на производстве, в диспетчерских, на удаленных объектах).</li>
                                <li>Возможность масштабирования системы.</li>
                            </ul>
                        </li>
                    </ul>


                </div>

            </div>
        </div>
    </Layout>
}
export const meta = {
    title: 'Приложение для сенсорных панелей',
    description: 'Приложение для сенсорных панелей(Touch Panel Application) представляет собой embedded версию клиента SCADA NPT Compact   для панелей отображения с сенсорным экраном.'
}
//export const doNotPrerender = false;